module.exports = __webpack_public_path__ + "img/no2.74374596.png";